export { TasksList as LoyaltyTasksList } from './TasksList';
